import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { history } from "../../../_helpers";
import alertService from "../../../_services/cart/alert.service";
import suscripcionService, { formatoFecha, formatoPrecio } from "../../../_services/cart/suscripcion.service";

/**
 * Confirmacion antes de ir a Mercado Pago a autorizar el debito. Portada de tienda-admin
 * (`core/payments/subscription-checkout`, 13b5a5b): mismos estados (loading, idle, redirecting, error),
 * textos y botones.
 *
 * Diferencia: en tienda-admin el front decidia "si es localhost, mock". Aca lo decide el back
 * (`app.mp.platform.mock`) y contesta `activadaSinPago`, asi un build de prod nunca puede saltearse MP.
 */
export const CheckoutSuscripcion = ({ match }) => {
    const planId = Number(match?.params?.planId);
    const [plan, setPlan] = useState(null);
    const [estado, setEstado] = useState(null);
    const [state, setState] = useState("loading");
    const [error, setError] = useState("");

    useEffect(() => {
        if (!planId) {
            setState("error");
            return;
        }
        Promise.all([suscripcionService.planes(), suscripcionService.estado(true).catch(() => null)])
            .then(([r, est]) => {
                const p = (r.planes || []).find((it) => it.id === planId) ?? null;
                setPlan(p);
                setEstado(est);
                setState(p ? "idle" : "error");
            })
            .catch(() => setState("error"));
    }, [planId]);

    // Si esta en prueba, el primer cobro es cuando la prueba termina.
    const primerCobro = estado?.vigente && estado?.trial ? estado.endDate : null;

    const iniciarCheckout = () => {
        if (!plan) return;
        setState("redirecting");
        setError("");
        suscripcionService
            .iniciar(plan.id)
            .then((res) => {
                if (res?.activadaSinPago) {
                    alertService.msg("Suscripción exitosa", "success");
                    history.push("/vendedor/suscripcion/ok");
                } else if (res?.initPoint) {
                    window.location.href = res.initPoint;
                } else {
                    setError("No se obtuvo la URL de pago. Intentá de nuevo.");
                    setState("error");
                }
            })
            .catch((err) => {
                setError(err?.message || "Error al iniciar la suscripción. Intentá de nuevo.");
                setState("error");
            });
    };

    return (
        <div className="suscripcion-checkout">
            <div className="suscripcion-checkout__card">
                {state === "loading" && (
                    <>
                        <FontAwesomeIcon icon="fa-solid fa-spinner" spin size="3x" />
                        <p className="suscripcion-checkout__sub">Cargando plan...</p>
                    </>
                )}

                {plan && state !== "loading" && (
                    <>
                        <FontAwesomeIcon icon="fa-solid fa-award" size="3x" className="suscripcion-checkout__icono" />
                        <h2>{plan.name}</h2>
                        <p className="suscripcion-checkout__sub">Suscripción mensual · Renovación automática</p>

                        <div className="suscripcion-checkout__precio">
                            <div>
                                <span className="suscripcion-checkout__monto">{formatoPrecio(plan.amount)}</span>
                                <span className="suscripcion-checkout__periodo">/mes</span>
                            </div>
                            <p>ARS · IVA incluido</p>
                        </div>

                        {primerCobro && (
                            <p className="suscripcion-checkout__nota">
                                Estás en tu prueba gratis: el primer cobro es el {formatoFecha(primerCobro)}, cuando termina.
                            </p>
                        )}

                        {error && <div className="cuenta-usuarios__error">{error}</div>}

                        {state === "idle" && (
                            <button type="button" className="button suscripcion-checkout__boton" data-type="accent" onClick={iniciarCheckout}>
                                Suscribirme ahora
                            </button>
                        )}

                        {state === "redirecting" && (
                            <p className="suscripcion-checkout__sub">
                                <FontAwesomeIcon icon="fa-solid fa-spinner" spin /> Redirigiendo a Mercado Pago...
                            </p>
                        )}

                        {state === "error" && (
                            <button
                                type="button"
                                className="button suscripcion-checkout__boton"
                                data-type="accent"
                                onClick={() => {
                                    setState("idle");
                                    setError("");
                                }}
                            >
                                Reintentar
                            </button>
                        )}

                        <button type="button" className="suscripcion-checkout__volver" onClick={() => history.push("/planes")}>
                            Volver a los planes
                        </button>
                    </>
                )}

                {!plan && state === "error" && (
                    <>
                        <p className="suscripcion-checkout__error">Plan no encontrado.</p>
                        <button type="button" className="suscripcion-checkout__volver" onClick={() => history.push("/planes")}>
                            Volver a los planes
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};
